module.exports = new __parcel__URL__("rocket.5b83577f.svg").toString();